/**
 * @author Ariel
 * @date 2022-04-29
 * @desc 测评报名管理列表页配置
 */
import React from 'react'
import {component_tool} from '../../../../tool';
import moment from "moment";

let {WizDataTable, WizButton} = component_tool;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}

export const columns = (self, data) => {
  return [
    {
      name: 'id',
      formItem: {type: 'hidden'}
    },
    {
      name: 'requirementPersonnelId',
      formItem: {type: 'hidden'}
    },
    {
      title: '岗位',
      name: 'positionName',
      tableItem: {},
    },
    {
      title: '姓名',
      name: 'fullName',
      tableItem: {},
    },
    {
      title: '短信通知状态',
      name: 'smsState',
      tableItem: {},
      dict: [
        {code: 1, codeName: '待发送'},
        {code: 2, codeName: '发送成功'},
        {code: 3, codeName: '发送失败'},
      ]
    },
    {
      title: '短信通知时间',
      name: 'smsTime',
      tableItem: {
        render: (text, record) => {
          return formatterDate(text)
        }
      }
    },
    {
      title: '是否触发预警',
      name: 'warnOff',
      tableItem: {},
      dict: [
        {code: 1, codeName: '是'},
        {code: 0, codeName: '否'},
        {code: -1, codeName: '否'},
      ]
    },
    {
      title: '预警通知状态',
      name: 'warnState',
      tableItem: {},
      dict: [
        {code: 1, codeName: '待发送'},
        {code: 2, codeName: '发送成功'},
        {code: 3, codeName: '发送失败'},
      ]
    },
    {
      title: '预警通知时间',
      name: 'warnTime',
      tableItem: {
        render: (text, record) => {
          return formatterDate(text)
        }
      }
    },
    {
      title: '是否提交报名',
      name: 'submitState',
      tableItem: {},
      dict: [
        {code: 0, codeName: '否'},
        {code: 1, codeName: '是'},
      ]
    },
    {
      title: '提交时间',
      name: 'applySubmitTime',
      tableItem: {
        render: (text, record) => {
          return formatterDate(text)
        }
      }
    },
    {
      title: '操作',
      tableItem: {
        width: 100,
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton tooltip="查看" onClick={e => self._onLookApplyInfo(record,e)}>
              查看
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    }
  ]
}
